<!-- @format -->

<template>
	<div id="selectmeds">
		<section id="mymedslist" v-if="display.includes('mymedslist')">
			<h1 class="section__header">My medicines</h1>
			<div v-if="mymeds.length < 1" class="info__panel">
				<img class="mt--small mb--small" :src=images.pills />
				<!-- <img v-if="!isapp" class="mt--small mb--small" src="../../../assets/medimg.svg" /> -->
				<p>You currently don't have any medicines added to your record.</p>
				<p>
					Create your personal list of medicines. Add notes, edit and delete medicines. You can include
					prescription and
					other medicines.
				</p>
			</div>
			<div v-if="mymeds.length > 0">
				<info-header>
					<div class="hdr__info-label">{{ mymeds.length }} medicine(s)</div>
					<div class="action-btn hdr__btn">
						<div @click="startaddmedicine">
							Add medicines
							<icon icon="plus" />
						</div>
					</div>
					<!-- <a class="button__default">
                    add
                    <icon icon="chevron-right" />
                  </a> -->
				</info-header>
				<ul v-if="mymeds.length > 0" class="link-list-group">
					<li class="link-list-group-item link-list-group-item__inner" v-for="(q, idx) in mymeds" :key="idx"
						@click="viewmed(q, idx)">
						{{ q.name }}
						<icon icon="chevron-right" />
					</li>
				</ul>
			</div>
			<div class="button-container mt--small" v-if="!mymeds.length > 0">
				<action-button class="button--primary">
					<div @click="startaddmedicine">Add medicines</div>
				</action-button>
			</div>
		</section>

		<!-- 
         // View medicine from record
            -->

		<section v-if="display.includes('med.readonly')">
			<page-header>
				<a class="page__header__back-btn" @click="cancelclicked"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Medicine</span>
			</page-header>
			<info-header>
				<div class="hdr__info-label">
					medicine
					<br />
					<strong>{{ currentmed.name }}</strong>
				</div>
				<div class="action-btn action-btn--default" @click="showmedinfo" v-if="currentmed.hasinfo">Info</div>
			</info-header>
			<div class="content__inner mb--sm">
				<div class="field-item">
					<p class="label">form of medicine (e.g. a tablet)</p>
					<p>
						<strong>{{ currentmed.form }}</strong>
					</p>
				</div>
				<div class="field-item">
					<p class="label">dosage</p>
					<p>
						<strong>{{ currentmed.dosage }}</strong>
					</p>
				</div>
				<div class="field-item">
					<p class="label">frequency</p>
					<p>
						<strong>{{ currentmed.freq }}</strong>
					</p>
				</div>
				<div class="field-item">
					<p class="label">Additional information</p>
					<p>
						<strong>{{ currentmed.info }}</strong>
					</p>
				</div>
			</div>
			<div class="button-container">
				<action-button class="button--primary">
					<div @click="editmed(currentmed)">Edit</div>
				</action-button>
			</div>
		</section>

		<!-- // End -->

		<!-- 
         // View medicine info from patient record
            -->
		<section v-if="display.includes('med.info')">
			<page-header>
				<a class="page__header__back-btn" @click.prevent="medinfobackclicked"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Medicine info</span>
			</page-header>
			<div class="content__inner">
				<div v-for="(m, idx0) in meddetails" :key="idx0">
					<div v-if="meddetails.length - 1 === idx0">
						<h2 class="mb--small">{{ m.name }}</h2>
						<!-- <div v-html="html" @click.prevent="handleClick"></div> -->
						<div @click.prevent="handleClick">
							<div v-for="(s, idx1) in m.mainEntityOfPage" :key="idx1">
								<accordion v-bind:title="s.headline">
									<div v-for="(s2, idx2) in s.mainEntityOfPage" :key="idx2">
										<div v-html="s2.text"></div>
									</div>
								</accordion>
							</div>
						</div>
						<div>
							<p class="mt--small">
								<a href="#" @click="nhsukclicked"
									title="Click here to view the NHS.UK website (This will open in a new window)."><img
									:src=images.nhsuk
										alt="Content supplied by the NHS website nhs.uk" class="qrs-info-credit" /></a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- // End -->

		<!-- 
         // Edit medicine from patient record
            -->

		<section v-if="display.includes('med.edit')">
			<page-header>
				<a class="page__header__back-btn" @click.prevent="displayclicked('med.readonly')"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Medicine info</span>
			</page-header>
			<info-header>
				<div class="hdr__info-label">
					medicine
					<br />
					<strong>{{ tempmed.name }}</strong>
				</div>
				<div class="action-btn action-btn--danger" @click="confirm_deletemed">Delete</div>
			</info-header>

			<div class="content__inner mb--sm">
				<div class="">
					<form>
						<div class="form-row" v-if="tempmed.type === 'freetext'">
							<div class="form-group">
								<label class="label" for="editname">medicine</label>
								<input v-model="tempmed.name" id="editname" class="form-control" />
							</div>
						</div>
						<div class="form-row">
							<div class="form-group">
								<label for="editform"><span class="s-label">form of medicine</span> (e.g. a tablet)</label>
								<input v-model="tempmed.form" id="editform" class="form-control" />
							</div>
						</div>
						<div class="form-row">
							<div class="form-group">
								<label for="editdosage"><span class="s-label">dosage</span> (e.g. 5ml, 10mg, 12mcg
									etc)</label>
								<input v-model="tempmed.dosage" id="editdosage" class="form-control" />
							</div>
							<!-- <div class="form-group col-sm-3">
                        <label for="editdosage_unit">unit</label>
                        <input
                          v-model="tempmed.dosage_unit"
                          id="editdosage_unit"
                          class="form-control"
                        />
                      </div> -->
						</div>
						<div class="form-row">
							<div class="form-group">
								<label for="editfreq"><span class="s-label">frequency</span> (e.g. once per day etc)</label>
								<input v-model="tempmed.freq" id="editfreq" class="form-control" />
							</div>
							<!-- <div class="form-group col-sm-3">
                        <label for="editfreq_unit">unit</label>
                        <input v-model="tempmed.freq_unit" id="editfreq_unit" class="form-control" />
                      </div> -->
						</div>
						<div class="form-row">
							<div class="form-group">
								<label for="editinfo"><span class="s-label">Additional information</span></label>
								<textarea v-model="tempmed.info" id="editinfo" maxlength="400" class="form-control" />
							</div>
						</div>
					</form>
				</div>
			</div>
			<div class="button-container">
				<action-button class="button--primary mb--xs">
					<div @click="savemed">Save changes</div>
				</action-button>

				<action-button class="button--secondary button-spacer--l">
					<div @click="canceleditclicked">Cancel</div>
				</action-button>
			</div>
			<modal v-bind:class="deletemedicine_confirm_css" title="Delete medicine">
				<div slot="body">Are you sure you want remove this medicine?</div>
				<div slot="footer">
					<ul class="modal__footer__container">
						<li>
							<a @click="confirm_no_deletemed" class="modal__button modal__button--cancel" role="button"
								title="Click here to cancel removing this medicine">Cancel</a>
						</li>
						<li>
							<a @click="confirm_yes_deletemed" role="button" class="modal__button modal__button--delete"
								title="Click here to confrim the deletion of this medicine">Delete</a>
						</li>
					</ul>
				</div>
			</modal>
		</section>

		<!-- // End -->

		<!-- 
         // Add medicine to patient record using A-Z list
            -->

		<section id="selectmeds-atoz" v-if="display.includes('atoz')">
			<page-header v-if="display.includes('az')">
				<a class="page__header__back-btn" @click="cancelclicked"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Add medicines</span>
			</page-header>
			<page-header v-if="display.includes('listbyletter')">
				<a class="page__header__back-btn" @click.prevent="displayclicked('atoz.az')"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Add medicines</span>
			</page-header>
			<page-header v-if="display.includes('fillin-med')">
				<a class="page__header__back-btn" @click.prevent="displayclicked('atoz.az')"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Add medicines</span>
			</page-header>

			<div class="tab tab__header azheader">
				<ul class="tab__list">
					<li class="tab__item">
						<span class="tab__link active">Medicines A-Z</span>
					</li>
					<li class="tab__item">
						<a class="tab__link" href="#" @click.prevent="displayclicked('freetext.medicinename')"
							aria-disabled="true" title="Click here to add a medicine manually">Add manually</a>
					</li>
				</ul>
			</div>

			<div class="content__inner" v-if="display.includes('az')">
				<div class="az-container">
					<ul class="link-list-group atozlist">
						<li v-bind:class="{ letter: true, active: q.Letter.Active }" v-for="q in ma2z.MedicinesAtoZ"
							:key="q.Letter.Name">
							<span v-if="q.Letter.Active" class="letter__inner activelink"
								@click.prevent="letterclicked(q.Letter.Name)" v-bind:title="q.Letter.Name">{{ q.Letter.Name
								}}</span>
							<span v-else class="letter__inner disabled">{{ q.Letter.Name }}</span>
						</li>
					</ul>
				</div>
				<div>
					<p class="mt--small">
						<a href="#" @click="nhsukclicked"
							title="Click here to view the NHS.UK website (This will open in a new window)."><img
							:src=images.nhsuk alt="Content supplied by the NHS website nhs.uk"
								class="qrs-info-credit" />
						</a>
					</p>
				</div>
			</div>

			<div class="listbyletter" v-if="display.includes('listbyletter')">
				<div class="row">
					<div class="col-sm-12">
						<div class="letter__label mt--small mb--xs">{{ filteredMedicines[0].Name.charAt(0) }}</div>
						<div class="link-list-group">
							<span @click="medicineselectclicked(q)" class="link-list-group-item link-list-group-item__inner"
								v-for="q in filteredMedicines" :key="q.Alias">
								{{ q.Name }}
								<icon class="icon--green" icon="plus" />
							</span>
						</div>
					</div>
				</div>
			</div>

			<div class="content__inner mb--sm" v-if="display.includes('fillin-med')">
				<div>
					<p>
						<strong>{{ selectedmedicine.name }}</strong>
					</p>
				</div>
				<div>
					<p>Please enter any additional information if applicable.</p>
				</div>
				<form>
					<div class="form-row">
						<div class="form-group col-xs-12 col-md-8">
							<label for="inputForm"><span class="s-label">form of medicine</span> (e.g. a tablet)</label>
							<input v-model="selectedmedicine.form" type="text" maxlength="400" class="form-control"
								id="inputForm" />
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-xs-12 col-md-8">
							<label for="inputDosage"><span class="s-label">dosage</span> (e.g. 5ml, 10mg, 10mcg etc)</label>
							<input v-model="selectedmedicine.dosage" type="text" maxlength="400" class="form-control"
								id="inputDosage" />
						</div>
						<!-- <div class="form-group col-xs-12 col-md-8">
                      <label for="inputUnit">unit (e.g. ml, mg, mcg etc)</label>
                      <input
                        v-model="selectedmedicine.dosage_unit"
                        type="text"
                        maxlength="400"
                        class="form-control"
                        id="inputUnit"
                      />
                    </div> -->
					</div>
					<div class="form-row">
						<div class="form-group col-xs-12 col-md-8">
							<label for="inputFrequency"><span class="s-label">frequency</span> (e.g. once per day
								etc)</label>
							<input v-model="selectedmedicine.freq" type="text" maxlength="400" class="form-control"
								id="inputFrequency" />
						</div>
						<!-- <div class="form-group col-xs-12 col-md-8">
                      <label for="inputFreqUnit">unit (e.g. per day etc)</label>
                      <input
                        v-model="selectedmedicine.freq_unit"
                        type="text"
                        maxlength="400"
                        class="form-control"
                        id="inputFreqUnit"
                      />
                    </div> -->
					</div>
					<div class="form-row">
						<div class="form-group col-xs-12 col-md-8">
							<label for="inputAdditionlInfo"><span class="s-label">Additional information (maximum of 400
									characters)</span></label>
							<textarea v-model="selectedmedicine.info" rows="3" maxlength="400" class="form-control"
								id="inputAdditionlInfo" />
						</div>
					</div>
				</form>
			</div>
			<div class="button-container" v-if="display.includes('fillin-med')">
				<action-button class="button--primary">
					<div @click="addmedicine(selectedmedicine)">Add</div>
				</action-button>
			</div>
		</section>

		<!-- // End -->

		<!-- 
         // Add medicine to patient record using free text
            -->

		<section id="selectmeds-freetext" v-if="display.includes('freetext')">
			<page-header>
				<a class="page__header__back-btn" @click="cancelclicked"
					title="Click here to go back to the previous section">
					<icon icon="chevron-left" />
				</a>
				<span>Add medicines</span>
			</page-header>

			<div id="freetext-medicinename" v-if="display.includes('freetext.medicinename')">
				<div class="tab tab__header azheader">
					<ul class="tab__list">
						<li class="tab__item">
							<a class="tab__link" href="#" @click.prevent="displayclicked('atoz.az')"
								title="Click here view the Medicines A-Z section">Medicines A-Z</a>
						</li>
						<li class="tab__item">
							<span class="tab__link active">Add manually</span>
						</li>
					</ul>
				</div>
				<div class="content__inner mb--sm">
					<div>
						<p>
							<strong>This section should be used only if medicines cannot be found in the A-Z
								lookup.</strong>
						</p>
						<p>Please enter name of the medicine below. This can include herbal and alternative medicines.</p>
					</div>
					<div class="form-group">
						<label for="inputFreetextMedicineName"><span class="s-label">medicine name</span> *</label>
						<input v-model="freetextmedicine.name" type="text" maxlength="400" class="form-control"
							id="inputFreetextMedicineName" />
					</div>
					<div v-if="freetextmedicine.name < 1">
						<ul class="error">
							<li>Please enter a medicine name</li>
						</ul>
					</div>
				</div>
				<div class="button-container">
					<action-button class="button--primary">
						<div @click.prevent="display_addfreetextmedicine_clicked">Add</div>
					</action-button>
				</div>
			</div>

			<div class="freetext-fillin-med" v-if="display.includes('freetext.fillin-med')">
				<info-header>
					<div class="hdr__info-label">
						medicine
						<br />
						<strong>{{ freetextmedicine.name }}</strong>
					</div>
				</info-header>
				<div class="content__inner mb--sm">
					<div>
						<p>Please enter any additional information if applicable.</p>
					</div>
					<form>
						<div class="form-row">
							<div class="form-group col-xs-12 col-md-8">
								<label for="inputForm"><span class="s-label">form of medicine</span> (e.g. a tablet)</label>
								<input v-model="freetextmedicine.form" type="text" maxlength="400" class="form-control"
									id="inputForm" />
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-xs-12 col-md-8">
								<label for="inputDosage"><span class="s-label">dosage</span> (5ml, 10mg, 12mcg etc)</label>
								<input v-model="freetextmedicine.dosage" type="text" maxlength="400" class="form-control"
									id="inputDosage" />
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-xs-12 col-md-8">
								<label for="inputFrequency"><span class="s-label">frequency</span> (e.g. once per day
									etc)</label>
								<input v-model="freetextmedicine.freq" type="text" maxlength="400" class="form-control"
									id="inputFrequency" />
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-xs-12 col-md-8">
								<label for="inputAdditionlInfo"><span class="s-label">Additional information (maximum of 400
										characters)</span></label>
								<textarea v-model="freetextmedicine.info" rows="3" class="form-control" maxlength="400"
									id="inputAdditionlInfo" />
							</div>
						</div>
					</form>
				</div>
				<div class="button-container">
					<action-button class="button--primary">
						<div @click="addmedicine(freetextmedicine)">Add</div>
					</action-button>
				</div>
			</div>
		</section>

		<!-- // End -->
	</div>
</template>

<script>
import axios from 'axios';
import images from '@/helpers/encodedImages.js';

export default {
	name: 'MyMedicineList',
	mounted() {
		setTimeout(
			function () {
				let bodyhtml = document.querySelector('body').innerHTML;
				if (bodyhtml.includes('--INAPP--')) {
					this.isapp = true;
				} else {
					this.isapp = false;
				}
			}.bind(this),
			500,
		);
		this.getdatafromfile();
		this.getfromdatastore((items) => {
      this.mymeds = items;
    });
	},
	data() {
		return {
			images: images,
			nhsuk: 'https://www.nhs.uk',
			isapp: true,
			display: 'mymedslist', //'atoz.az',
			deletemedicine_confirm_css: '',
			ma2z: {},
			letter: 'B',
			currentmed: {},
			currentmedindex: -1,
			html: '',
			meddetails: [],
			tempmed: {},
			selectedmedicine: {
				name: '',
				id: '',
				form: '',
				dosage: '',
				//dosage_unit: "",
				freq: '',
				//freq_unit: "",
				info: '',
				html: '',
				type: 'atoz',
				data_added: '',
			},
			freetextmedicine: {
				name: '',
				id: '',
				form: '',
				dosage: '',
				//dosage_unit: "",
				freq: '',
				//freq_unit: "",
				info: '',
				html: '',
				type: 'freetext',
				data_added: '',
			},
			mymeds: [
				/*
  {
	name:"test one",
	id:"01",
	form:"Capsule",
	dosage:"50",
	dosage_unit:"mg",
	freq:"once",
	freq_unit:"daily",
	info:"some additonal information",
	html:"",
	type:"freetext",
	data_added:""
  }*/
			],
		};
	},

	computed: {
		filteredMedicines() {
			var list = this.ma2z.MedicinesAtoZ.filter((m) => {
				return m.Letter.Name.match(this.letter.toUpperCase());
			});
			return list[0].Medicines;
		},
	},
	methods: {
		nhsukclicked() {
			if (this.isapp) {
				let d = { title: '', nodeid: -1, href: '', target: '' };
				d.href = this.nhsuk;
				d.target = '_blank';
				window.Native('dataCallback', d);
				return false;
			} else {
				let win = window.open(this.nhsuk, '_blank');
				win.focus();
			}
		},
		handleClick(e) {
			if (e.target.matches('a')) {
				let url = e.target.href;
				let bodyhtml = document.querySelector('body').innerHTML;
				e.target.setAttribute('protected', null); //setting these attributes to null causes the app to skip over this link
				e.target.setAttribute('href', null); // i.e. not open it in an external browser
				console.log(url);
				if (url.startsWith('https://api.nhs.uk/medicines')) {
					let medalias_temp = url.replace('https://api.nhs.uk/medicines/', '');
					let medalias_temp2 = medalias_temp.split('/');
					let medalias = medalias_temp2[0];
					if (medalias.length > 0) {
						let _firstletter = medalias.substring(0, 1).toUpperCase();
						this.ma2z.MedicinesAtoZ.forEach((s) => {
							if (s.Letter.Name === _firstletter) {
								s.Medicines.forEach((m) => {
									if (m.Alias === medalias) {
										setTimeout(
											function () {
												this.getMedicineByName(m.Name);
											}.bind(this),
											500,
										);

										//this.display = "med.tempinfo";
										//this.displayclicked('med.readonly')
										//this.getMedicineByName(m.Name);
										//this.display = "med.info";
										//this.medicineclicked(m);
									}
								});
							}
						});
					}
				} else if (bodyhtml.includes('--INAPP--')) {
					console.log('fire native event');
					let _u = encodeURI(url);
					axios
						.post(
							'https://127.0.0.1:8989/datastore/nav/url',
							{ data: _u },
							{
								headers: {
									'Content-Type': 'application/json',
								},
							},
						)
						.then((response) => {
							console.log(response.data);
						})
						.catch((error) => {
							console.log('failed' + error);
						});
				} else {
					if (!url.startsWith('https://api.nhs.uk/medicines')) {
						let win = window.open(url, '_blank');
						win.focus();
					}
				}
			}
		},
		displayclicked(display) {
			this.display = display;
		},
		viewmed(med, idx) {
			this.currentmedindex = idx;
			this.currentmed = med;
			this.getMedicineByName(this.currentmed.name);
			this.display = 'med.readonly';
		},
		showmedinfo() {
			//this.html = this.getHtmlByName(this.currentmed.name);
			this.getMedicineByName(this.currentmed.name);
			this.display = 'med.info';
		},
		medinfobackclicked() {
			if (this.meddetails.length > 1) {
				this.meddetails.pop();
			} else {
				this.display = 'med.readonly';
			}
		},
		editmed(med) {
			this.tempmed = {
				name: med.name,
				id: med.id,
				form: med.form,
				dosage: med.dosage,
				//dosage_unit: med.dosage_unit,
				freq: med.freq,
				//freq_unit: med.freq_unit,
				info: med.info,
				html: med.html,
				type: med.type,
			};
			//this.currentmed = med;
			this.display = 'med.edit';
		},
		canceleditclicked() {
			this.tempmed = {
				name: '',
				id: '',
				form: '',
				dosage: '',
				dosage_unit: '',
				freq: '',
				freq_unit: '',
				info: '',
				html: '',
				type: '',
			};
			this.display = 'med.readonly';
		},
		savemed() {
			this.currentmed.name = this.tempmed.name;
			this.currentmed.id = this.tempmed.id;
			this.currentmed.form = this.tempmed.form;
			this.currentmed.dosage = this.tempmed.dosage;
			//this.currentmed.dosage_unit = this.tempmed.dosage_unit;
			this.currentmed.freq = this.tempmed.freq;
			//this.currentmed.freq_unit = this.tempmed.freq_unit;
			this.currentmed.info = this.tempmed.info;
			this.currentmed.html = this.tempmed.html;
			this.currentmed.type = this.tempmed.type;
			this.display = 'mymedslist';
			this.savetodatastore();
		},
		confirm_deletemed() {
			this.deletemedicine_confirm_css = 'modal__container--active';
		},
		confirm_yes_deletemed() {
			this.deletemedicine_confirm_css = '';
			this.deletemed();
		},
		confirm_no_deletemed() {
			this.deletemedicine_confirm_css = '';
		},
		deletemed() {
			if (this.currentmedindex > -1) {
				this.currentmed = {};
				this.mymeds.splice(this.currentmedindex, 1);
				this.display = 'mymedslist';
				this.savetodatastore();
			}
			this.currentmedindex = -1;
		},
		cancelclicked() {
			this.display = 'mymedslist';
			this.currentmedindex = -1;
		},
		display_addfreetextmedicine_clicked() {
			if (this.freetextmedicine.name.length > 0) {
				this.display = 'freetext.fillin-med';
			}
		},
		startaddmedicine() {
			//this.getdatafromfile();
			this.freetextmedicine.name = '';
			this.display = 'atoz.az';
		},
		letterclicked(selectedletter) {
			this.letter = selectedletter;
			this.display = 'atoz.listbyletter';
		},
		medicineselectclicked(med) {
			this.selectedmedicine.name = med.Name;
			this.selectedmedicine.html = '';
			this.selectedmedicine.form = '';
			this.selectedmedicine.dosage = '';
			this.selectedmedicine.freq = '';
			this.selectedmedicine.info = '';
			this.selectedmedicine.html = '';
			this.selectedmedicine.type = 'atoz';
			this.selectedmedicine.data_added = '';

			this.display = 'atoz.fillin-med';
		},
		addmedicine(med) {
			if (med.name.length > 0) {
				let _hasinfo = false;
				if (med.type === 'atoz') {
					_hasinfo = true;
				} else {
					let _medname = this.getMedicineByName(med.name);
					if (_medname) {
						_hasinfo = true;
						med.type = 'atoz';
					}
				}

				let newmed = {
					name: med.name,
					id: med.id,
					form: med.form,
					dosage: med.dosage,
					freq: med.freq,
					info: med.info,
					html: med.html,
					type: med.type,
					hasinfo: _hasinfo,
					data_added: '',
				};
				this.mymeds.push(newmed);
				let _emptymed = {
					name: '',
					id: '',
					form: '',
					dosage: '',
					freq: '',
					info: '',
					html: '',
					type: 'freetext',
					data_added: '',
				};
				this.freetextmedicine = _emptymed;
				//this.selectedmedicine = _emptymed;

				this.display = 'mymedslist';
				this.savetodatastore();
				//this.getfromdatastore();
			}
		},
		getfromdatastore(_callback) {
			console.log('getfromdatastore');
			if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
				window.flutter_inappwebview.callHandler = function () {
					var _callHandlerID = setTimeout(function () { });
					window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
					return new Promise(function (resolve, reject) {
						console.log(typeof (reject)); //this line is just to avoid unused variable error
						window.flutter_inappwebview[_callHandlerID] = resolve;
					});
				};
			}
			window.flutter_inappwebview.callHandler('GET:MYMEDICINELIST').then(function (result) {
				console.log(result);
				let res0 = atob(result);
				let res1 = JSON.parse(res0);
				console.log("just about to load medicines from app storage");
				console.log(res1);
				_callback(res1);
				console.log(res1);
			}).catch((error) => {
				console.log('failed' + error);
			});
		},
		savetodatastore() {
			console.log('savetodatastore');
			let data1 = JSON.stringify(this.mymeds);
			console.log(data1);
			let data2 = btoa(data1);
			let data0 = data2;
			alert("SAVE:MYMEDICINELIST:" + data0);
		},
		getdatafromfile() {
			console.log('getdatafromfile');
			let bodyhtml = document.querySelector('body').innerHTML;
			if (bodyhtml.includes('--INAPP--')) {
				axios.get('https://127.0.0.1:8989/datastore/readfile/medicinesdata/medicines.json').then((response) => {
					if (response.status == 200) {
						console.log('getdatafromfile : 200');
						this.ma2z = response.data;
					}
				});
			} else {
				axios.get('https://nsspolypharmacy.azurewebsites.net/medicinesdata/medicines.json').then((response) => {
					if (response.status == 200) {
						console.log('getdatafromfile : 200');
						//let res0 = atob(response.data);
						//let res1 = JSON.parse(res0);
						this.ma2z = response.data;
					}
				});
			}
		},
		removemedicine() {
			console.log('removemedicine');
		},
		updatemedicine() {
			console.log('updatemedicine');
		},
		gethtml(jsdata) {
			let html = [];

			let temp = jsdata; //JSON.parse(jsdata);
			//console.log(temp);
			if (temp.mainEntityOfPage) {
				temp.mainEntityOfPage.forEach((element) => {
					if (element.text) {
						html.push('<div class="element">');
						html.push(element.text);
						html.push('</div>');
					}
					if (element.mainEntityOfPage) {
						element.mainEntityOfPage.forEach((element2) => {
							if (element2.text) {
								html.push('<div class="elementchild">');
								html.push(element2.text);
								html.push('</div>');
							}
						});
					}
				});
			}
			return html.join('');
		},
		getHtmlByName(name) {
			let html = '';
			let initial = name.substring(0, 1);
			let group = this.ma2z.MedicinesAtoZ.filter((m) => {
				return m.Letter.Name.match(initial.toUpperCase());
			});
			if (group[0]) {
				let meds = group[0].Medicines;
				meds.forEach((el) => {
					if (el.Name.toLowerCase() === name.trim().toLowerCase()) {
						let obj = el.Detail;
						obj.mainEntityOfPage.forEach((el) => {
							el.mainEntityOfPage.forEach((el2) => {
								html = html + "<div class='element'>" + el2.text + '</div>';
							});
						});
					}
				});
			}
			return html;
		},
		getMedicineByName(name) {
			//let html = "";
			let _matchatoz = false;
			let initial = name.substring(0, 1);
			let group = this.ma2z.MedicinesAtoZ.filter((m) => {
				return m.Letter.Name.match(initial.toUpperCase());
			});
			if (group[0]) {
				let meds = group[0].Medicines;
				meds.forEach((el) => {
					if (el.Name.toLowerCase() === name.trim().toLowerCase()) {
						this.meddetails.push(el.Detail);
						_matchatoz = true;
						//this.meddetails = el.Detail;
					}
				});
			}

			return _matchatoz;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/layouts/header.scss';
@import '../../../scss/elements/_buttons.scss';
@import '../../../scss/elements/_panels.scss';
@import '../../../scss/elements/_listing.scss';
@import '../../../scss/controls/_tabs.scss';
@import '../../../scss/forms/_form.scss';
</style>
